import { render, staticRenderFns } from "./drawList.vue?vue&type=template&id=5d4fcc3a&scoped=true&"
import script from "./drawList.vue?vue&type=script&lang=js&"
export * from "./drawList.vue?vue&type=script&lang=js&"
import style0 from "./drawList.vue?vue&type=style&index=0&id=5d4fcc3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4fcc3a",
  null
  
)

export default component.exports